import { css, keyframes } from 'styled-components';

const ANIMATION_FADEIN = keyframes`
  0% {
    transform: translateY(2.5px); 
    opacity: 0.5;
  }
  50% {
    transform: translateY(-2.5px); 
  }
  100% {
    transform: translateY(0px); 
    opacity: 1;
  }
`;

const ANIMATION_FADEOUT = keyframes`
  0% {
    transform: translateY(0px); 
    opacity: 1;
  }
  50% {
    transform: translateY(-2.5px); 
  }
  100% {
    transform: translateY(2.5px); 
    opacity: 0;
  }
`;

const ANIMATION_SLIDEIN = keyframes`
  0% {
    opacity: 0.2;
    transform: translateX(-10px); 
  }
  100% {
    opacity: 1;
    transform: translateX(0px); 
  }
`;

const ANIMATION_ZOOM_IN_ROTATE = keyframes`
  0% {
    opacity: 0;
    transform: scale(0, 0) rotate(0deg); 
  }
  80% {
    transform: scale(1.1, 1.1) rotate(360deg); 
  }
  100% {
    transform: scale(1.0, 1.0) rotate(360deg); 
  }
`;

const ANIMATION_ZOOM_OUT_TOP = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0px); 
  }
  20% {
    transform: translateY(5px); 
  }
  100% {
    opacity: 0;
    transform: translateY(-45px); 
  }
`;

const ANIMATION_ZOOM_IN = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.9, 0.9); 
  }
  100% {
    transform: scale(1.0, 1.0); 
  }
`;

const ANIMATION_ZOOM_IN_FAST = keyframes`
  0% {
    opacity: 0.5;
    transform: scale(0.8, 0.8); 
  }
  60% {
     transform: scale(1.02, 1.02); 
  }
  100% {
    opacity: 1;
    transform: scale(1.0, 1.0); 
  }
`;

const ANIMATION_FADE_IN_LEFT = keyframes`
  0% {
    transform: translateX(20px); 
    opacity: 0;
  }
  60% {
    transform: translateX(-5px); 
  }
  100% {
    transform: translateX(0px); 
    opacity: 1;
  }
`;

const getDropInAnimation = (height) => keyframes`
  0% {
    transform: translateY(-${height}); 
  }
  100% {
    transform: translateY(0px); 
  }
`;

const ANIMATION_SLIDE_IN_BOTTOM = keyframes`
  0% {
    opacity: 0;
    transform: translateY(25px); 
  }
  20% {
    opacity: 1;
  }
  100% {
    transform: translateY(0px); 
    opacity: 1;
  }
`;

export const slideInBottom = (delay) => css`
  transform: translateY(25px);
  opacity: 0;

  will-change: transform, opacity;
  animation-delay: ${delay};
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  animation-name: ${ANIMATION_SLIDE_IN_BOTTOM};
`;

export const dropIn = (height) => css`
  transform: translateY(-${height});

  will-change: transform;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  animation-name: ${getDropInAnimation(height)};
`;

export const zoomOutTop = css`
  transform: translateY(0px);
  opacity: 0;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  animation-name: ${ANIMATION_ZOOM_OUT_TOP};
`;

export const fadeInLeft = css`
  transform: translateX(20px);

  opacity: 0;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  animation-name: ${ANIMATION_FADE_IN_LEFT};
`;

export const zoomInRotate = css`
  animation-delay: 0.2s;
  animation-duration: 0.5s;
  transform: scale(0, 0);
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  animation-name: ${ANIMATION_ZOOM_IN_ROTATE};
`;

export const zoomIn = css`
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-timing-function: ease;
  animation-name: ${ANIMATION_ZOOM_IN};
`;

export const zoomInFast = css`
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-name: ${ANIMATION_ZOOM_IN_FAST};
`;

export const fadeIn = css`
  opacity: 0;
  animation-delay: 0.1s;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  will-change: opacity, transform;
  animation-name: ${ANIMATION_FADEIN};
  animation-timing-function: ease-out;
`;

export const fadeOut = css`
  opacity: 1;
  animation-delay: 0.1s;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  will-change: opacity, transform;
  animation-name: ${ANIMATION_FADEOUT};
  animation-timing-function: ease-out;
`;

export const slideIn = css`
  opacity: 0.2;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  transform: translateX(-10px);
  will-change: opacity, transform;
  animation-name: ${ANIMATION_SLIDEIN};
  animation-timing-function: ease-in;
`;
